import { useEffect, useState, useCallback } from 'react';
// REACT ROUTER IMPORTS
import { useSearchParams, useNavigate } from 'react-router-dom';
// NPM IMPORTS
import _ from 'lodash';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import searchFill from '@iconify/icons-eva/search-fill';
import { useConfirm } from 'material-ui-confirm';
import { useSnackbar } from 'notistack5';
import moment from 'moment';
// MATERIAL IMPORTS
import {
    Box,
    Button,
    Paper,
    CircularProgress,
    Divider,
    IconButton,
    InputAdornment,
    OutlinedInput,
    Stack,
    Table,
    TableRow,
    TableBody,
    TableHead,
    TableCell,
    TableContainer,
    tableCellClasses,
    TablePagination,
    Typography,
    Tooltip,
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { CheckBox, StopCircleOutlined } from "@material-ui/icons";
import { MainBlockV2 } from '../../../MainBlockV2';
// COMPONENT IMPORTS
import { MIconButton } from '../../../../../components/@material-extend';
import Scrollbar from '../../../../../components/Scrollbar';
import { PATH_EMP } from "../../../../../routes/paths";
import { myscorelistApi, myscoreSearchlistApi } from '../../../../../_apis_/authApi.js/empapi';
//
import SortingSelectingMyScore from './SortingSelectingMyScore';
import ScoreWrapper from '../../../../scorecomponent/scorewrapper';
import PaginationTable from '../../../../Common Component/PaginationTable';



// ----------------------------------------------------------------------



const TABLE_HEAD = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'Id'
    },
    {
        id: 'grp',
        numeric: false,
        disablePadding: false,
        label: 'Group'
    },
    {
        id: 'Event Date',
        numeric: false,
        disablePadding: false,
        label: 'Event Date'
    },
    {
        id: 'category',
        numeric: false,
        disablePadding: false,
        label: 'Category'
    },
    {
        id: 'Evaluator',
        numeric: false,
        disablePadding: false,
        label: 'Evaluator'
    },
    {
        id: 'score',
        numeric: false,
        disablePadding: false,
        label: 'Score'
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'Status'
    },
    {
        id: 'feedaback',
        numeric: false,
        disablePadding: false,
        label: 'Feedback Date'
    },
    {
        id: 'reviewdby',
        numeric: false,
        disablePadding: false,
        label: 'Reviewed By'
    },
    {
        id: 'Action',
        numeric: false,
        disablePadding: false,
        label: 'Action'
    },

];

// ----------------------------------------------------------------------

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
    width: 150,
    height: 45,
    color: `${theme.palette.functionalityBtn} !important`,
    transition: theme.transitions.create(['box-shadow', 'width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter
    }),
    '&.Mui-focused': { width: 150, boxShadow: theme.customShadows.z8 },
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${theme.palette.grey[500_32]} !important`,
        border: 'none !important',
        color: `${theme.palette.functionalityBtn} !important`, fontWeight: '100 !important'
    },
    '& .MuiOutlinedInput-input::placeholder': {
        color: `${theme.palette.functionalityBtn} !important`, // Change this color to your desired placeholder color,
        fontFamily: 'Nunito, sans-serif'
    }
}));


export default function ListScore() {
    const mbLink = [];
    // LOCAL STORAGE
    const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));
    // REACT ROUTER STATES
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    // REACT STATES
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [tableOrder, setTableOrder] = useState(false);
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(1);
    const [pageRange, setPageRange] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [filterName, setFilterName] = useState('');

    useEffect(() => {
        // dispatch(getScoreList(searchParams.get("empId"), 1))
        (async function () {
            try {
                setData([]);
                setIsLoading(true);
                const response = await myscorelistApi(searchParams.get("date1"), searchParams.get("date2"), searchParams.get("range"), searchParams.get("date_number"), searchParams.get("staff"), searchParams.get("scorecard"));
                // console.log(response?.data?.results)
                setData(response?.data?.results)
                setPageRange(response?.data?.page_range?.length);
                setCount(response?.data?.count)
                setIsLoading(false);

            } catch (err) {
                if (err) {
                    setPageRange(1);
                    console.log(err)
                    setIsLoading(false);
                }
            }
        })();
    }, [])


    const getMyscoreData = async (pg) => {
        try {
            setData([]);
            setIsLoading(true);
            const response = await myscorelistApi(searchParams.get("date1"), searchParams.get("date2"), searchParams.get("range"), searchParams.get("date_number"), searchParams.get("staff"), searchParams.get("scorecard"), pg);
            // console.log(response?.data?.results)
            setData(response?.data?.results)
            setPageRange(response?.data?.page_range?.length);
            setCount(response?.data?.count)
            setIsLoading(false);

        } catch (err) {
            if (err) {
                setPageRange(1);
                console.log(err)
                setIsLoading(false);
            }
        }


    }

    const searchMyScoreData = async (pg, value) => {
        setPageRange(1)
        setData([]);
        setIsLoading(true);

        const response = await myscoreSearchlistApi(searchParams.get("date1"), searchParams.get("date2"), searchParams.get("range"), searchParams.get("date_number"), searchParams.get("staff"), searchParams.get("scorecard"), value, pg);
        // console.log(response)
        setIsLoading(false);
        setCount(response?.data?.count)
        setData(response?.data?.results)
        setPageRange(response?.data?.page_range?.length)
    }


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = data.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleChangePage = (event, newPage) => {
        setData([]);
        setIsLoading(true);
        if (filterName && filterName !== "") {
            searchMyScoreData(newPage);
            return setPage(newPage);
        }
        getMyscoreData(newPage);

        return setPage(newPage);

    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleTableOrder = () => {
        setData(data?.reverse());
        setTableOrder(!tableOrder);
    }


    const sendQuery = (queryText) => {
        if (queryText?.length === 0) {
            return getMyscoreData();
        }
        if (queryText?.length > 0) {
            return searchMyScoreData(1, queryText);
        }
    }

    const delayedQuery = useCallback(_.debounce((query) => sendQuery(query), 1000), []);

    const handleFilterByName = (event) => {
        setData([]);
        setIsLoading(true);
        setPage(1);
        setPageRange(1);
        setFilterName(event.target.value)
        delayedQuery((event.target.value)?.trim());

    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    return (
        <>
            <Box
                component={Paper}
                elevation={5}
                sx={{ backgroundColor: (theme) => theme.palette.background.paper, borderRadius: '5px', mt: 0 }}
            >

                <MainBlockV2 title="My Score" MBLinks={[{ name: 'Home', href: PATH_EMP?.dashboard }, { name: 'Back', href: -1 }, { name: 'My Scores' }]}
                    buttonType={

                        <SearchStyle
                            value={filterName}
                            onChange={handleFilterByName}
                            placeholder="Search..."
                            startAdornment={
                                <>
                                    <InputAdornment position="start">
                                        <Box component={Icon} icon={searchFill} sx={{ color: theme => theme.palette.functionalityBtn, }} />
                                    </InputAdornment>
                                </>
                            }

                        />


                    }
                >




                    {/* <Divider /> */}
                    <Scrollbar >
                        <TableContainer variant='standard'>
                            <Table size='small'>
                                <TableHead>
                                    {TABLE_HEAD?.map(obj => <TableCell align='center'>
                                        {obj?.label}
                                    </TableCell>)}
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, index) => {


                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row.id}
                                                sx={{
                                                    [`& .${tableCellClasses.root}`]: {
                                                        py: 1,
                                                        borderBottom: (theme) => `1px solid ${(index !== data?.length - 1) ? `${theme.palette.text.primaryBorder}` : 'transparent'}`,
                                                    },
                                                }}
                                            >
                                                <TableCell scope="row" align="center" >
                                                    <Box sx={{ width: "100%" }}>
                                                        {row?.id}
                                                    </Box>
                                                </TableCell>
                                                <TableCell align='center' scope="row" padding="normal">
                                                    <Box sx={{ width: "100%" }}>
                                                        <Button sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px' }} variant="outlined" color="inherit">{row?.groups}</Button>
                                                    </Box>

                                                </TableCell>

                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box sx={{ width: "100%" }}>
                                                        <Typography sx={{ fontSize: "13px" }}>{row?.event_date}</Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box sx={{ width: "100%" }}>
                                                        <Button sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px' }} variant="outlined" color="inherit">{row?.category}</Button>

                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box sx={{ width: "100%" }}>
                                                        <Button sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px' }} variant="outlined" color="inherit">{row?.evaluator}</Button>

                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box display="flex" justifyContent="center">

                                                        {row?.score_result === 20 && <Button variant="contained" sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px', color: "white", backgroundColor: "#55efc4" }} color="inherit">{row?.percentage}%</Button>}
                                                        {row?.score_result === 10 && <Button variant="contained" sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px', color: "white", backgroundColor: "#e74c3c" }} color="inherit">{row?.percentage}%</Button>}
                                                        {row?.score_result === 30 && <Button variant="contained" sx={{ padding: '0px 8px', mx: 1, fontSize: "12px", fontWeight: '400', marginRight: '5px', marginBottom: '2px', color: "white", backgroundColor: "#feca57" }} color="inherit">{row?.percentage}%</Button>}

                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box display="flex" justifyContent="center">
                                                        {row?.is_score_reviewed && <CheckBox />}
                                                        {!row?.is_score_reviewed && <StopCircleOutlined />}
                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box display="flex" justifyContent="center">
                                                        {row?.is_score_reviewed && <Typography sx={{ fontSize: "14px" }}>{moment(row?.score_reviewed_on).format("LL")}</Typography>}
                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box display="flex" justifyContent="center">
                                                        <Typography sx={{ fontSize: "14px" }}>{row?.score_reviewed_by}</Typography>
                                                    </Box>

                                                </TableCell>
                                                <TableCell align="center" scope="row" padding="normal">
                                                    <Box display="flex" justifyContent="center">

                                                        <Button sx={{ mx: 1, backgroundColor: (theme) => theme.palette.background.paper, '&:hover': { backgroundColor: (theme) => theme.palette.background.paper, color: '#fb5d2e' }, color: '#fb5d2e', boxShadow: 'none', fontWeight: 'normal', borderRadius: '5px', fontSize: '14px', border: '1px solid #dddde7' }} variant="contained" onClick={() => { navigate(searchParams.get("stff_emp_id") ? `/reports/reviewPerformance?score_card_Id=${row?.score_card}&score_Id=${row?.id}&review=True&sup_view=True` : `/reports/reviewPerformance?score_card_Id=${row?.score_card}&score_Id=${row?.id}&review=True`) }} >View</Button>
                                                    </Box>

                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                    {data?.length === 0 && (
                                        <TableRow>



                                            {isLoading ? <TableCell colSpan={12}>
                                                <Box display="flex" justifyContent="center" alignContent="cneter" sx={{ py: 2 }}>
                                                    <CircularProgress /> Loading Scores...
                                                </Box>
                                            </TableCell> : <TableCell colSpan={12}>
                                                <Typography gutterBottom align="center" variant="subtitle1" sx={{ py: 2 }}>
                                                    No Scores Found
                                                </Typography>
                                            </TableCell>}

                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                        </TableContainer>


                        <PaginationTable
                            count={count || 0}
                            tablePage={(page - 1)}
                            // tablePage={showPage ? cPage - 1 : page - 1} // for tablepagination component
                            pageRange={pageRange}
                            // page={showPage ? cPage : page} // for pagination component
                            page={page}
                            handlePagination={handleChangePage}
                            style={{ ml: 'auto', color: '#212668', fontWeight: 700 }}
                        />

                    </Scrollbar>
                </MainBlockV2>
            </Box>
        </>
    );
}
